import { SideNavFeatures } from '@app/interfaces/sideNavigation';
import { useAppSelector } from './reduxHooks';
import {
  breedingJournalAclSelector,
  inspectionsAclSelector,
  observationsAclSelector,
  paperStatisticsAclSelector,
  professionalFisherAclSelector,
  allProfessionalFishersAclSelector,
  isProfessionalFisherSelector,
  reportsAclSelector,
  workflowsAclSelector,
  generalSettingsAclSelector,
  netTypesAclSelector,
  waterBodiesAclSelector,
  waterbodyRegulationsAclSelector,
  geographicAreasAclSelector,
  licenseTypesAclSelector,
  fishTypesAclSelector,
  fishingFeesAclSelector,
  huntingFeesAclSelector,
  membersAclSelector,
  rolesAclSelector,
  organisationalUnitsAclSelector,
  inboxMessagesAclSelector,
  adminUsersAclSelector,
  analyticsFishingOperationsAclSelector,
  analyticsFishingManagementAclSelector,
  analyticsFishingHabitatAclSelector,
  analyticsProfessionalFishersAclSelector,
  analyticsHuntingOperationsAclSelector,
  huntingInspectionsAclSelector,
  gamesAclSelector,
  huntersAclSelector,
  huntingLicensesAclSelector,
  stockingPlanAclSelector,
  stockingJournalAclSelector,
  stockingYearlySummaryAclSelector,
  inventoryAclSelector,
  naturalBreedingAclSelector,
  fishMovementAclSelector,
  draughtinessAclSelector,
  waterQualityAclSelector,
  licensesAclSelector,
  licensesReturnAclSelector,
  fishersAclSelector,
  sessionsAclSelector,
  catchesAclSelector,
  analyticsSummaryAclSelector,
  analyticsBasicStatisticsAclSelector,
  dashboardHomeAclSelector,
} from '@app/store/slices/userSlice';

function useNavMenuFeatures(): SideNavFeatures {
  const features: SideNavFeatures = {};

  features['homeFeature'] = useAppSelector(dashboardHomeAclSelector);
  features['licensesFeature'] = useAppSelector(licensesAclSelector);
  features['licensesReturnFeature'] = useAppSelector(licensesReturnAclSelector);
  features['fishersFeature'] = useAppSelector(fishersAclSelector);
  features['sessionsFeature'] = useAppSelector(sessionsAclSelector);
  features['catchesFeature'] = useAppSelector(catchesAclSelector);
  features['inspectionsFeature'] = useAppSelector(inspectionsAclSelector);
  features['paperStatisticsFeature'] = useAppSelector(paperStatisticsAclSelector);

  features['inventoryFeature'] = useAppSelector(inventoryAclSelector);
  features['naturalBreedingFeature'] = useAppSelector(naturalBreedingAclSelector);
  features['stockingPlanFeature'] = useAppSelector(stockingPlanAclSelector);
  features['stockingJournalFeature'] = useAppSelector(stockingJournalAclSelector);
  features['stockingYearlySummaryFeature'] = useAppSelector(stockingYearlySummaryAclSelector);
  features['breedingJournalFeature'] = useAppSelector(breedingJournalAclSelector);

  features['fishMovementFeature'] = useAppSelector(fishMovementAclSelector);
  features['observationsFeature'] = useAppSelector(observationsAclSelector);
  features['draughtinessFeature'] = useAppSelector(draughtinessAclSelector);
  features['waterQualityFeature'] = useAppSelector(waterQualityAclSelector);

  const isProfessionalFisher = useAppSelector(isProfessionalFisherSelector);
  const professionalFisherFeature = useAppSelector(professionalFisherAclSelector);
  const allProfessionalFishersFeature = useAppSelector(allProfessionalFishersAclSelector);

  features['professionalFisherFeature'] = professionalFisherFeature && {
    ...professionalFisherFeature,
    visible: !!professionalFisherFeature.visible && isProfessionalFisher,
  };
  features['allProfessionalFishersFeature'] = allProfessionalFishersFeature && {
    ...allProfessionalFishersFeature,
    visible: !!allProfessionalFishersFeature.visible && !isProfessionalFisher,
  };

  features['huntersFeature'] = useAppSelector(huntersAclSelector);
  features['killsFeature'] = useAppSelector(gamesAclSelector);
  features['huntingInspectionsFeature'] = useAppSelector(huntingInspectionsAclSelector);
  features['huntingLicensesFeature'] = useAppSelector(huntingLicensesAclSelector);

  features['analyticsFishingOperationsFeature'] = useAppSelector(analyticsFishingOperationsAclSelector);
  features['analyticsFishingManagementFeature'] = useAppSelector(analyticsFishingManagementAclSelector);
  features['analyticsFishingHabitatFeature'] = useAppSelector(analyticsFishingHabitatAclSelector);
  features['analyticsProfessionalFishersFeature'] = useAppSelector(analyticsProfessionalFishersAclSelector);
  features['analyticsHuntingOperationsFeature'] = useAppSelector(analyticsHuntingOperationsAclSelector);
  features['analyticsSummaryFeature'] = useAppSelector(analyticsSummaryAclSelector);
  features['analyticsBasicStatisticsFeature'] = useAppSelector(analyticsBasicStatisticsAclSelector);

  features['membersFeature'] = useAppSelector(membersAclSelector);
  features['rolesFeature'] = useAppSelector(rolesAclSelector);
  features['organisationalUnitsFeature'] = useAppSelector(organisationalUnitsAclSelector);
  features['inboxMessagesFeature'] = useAppSelector(inboxMessagesAclSelector);
  features['adminUsersFeature'] = useAppSelector(adminUsersAclSelector);

  features['waterbodiesFeature'] = useAppSelector(waterBodiesAclSelector);
  features['waterbodyRegulationsFeature'] = useAppSelector(waterbodyRegulationsAclSelector);
  features['geographicAreasFeature'] = useAppSelector(geographicAreasAclSelector);
  features['licenseTypesFeature'] = useAppSelector(licenseTypesAclSelector);
  features['fishTypesFeature'] = useAppSelector(fishTypesAclSelector);
  features['netTypesFeature'] = useAppSelector(netTypesAclSelector);
  features['fishingFeesFeature'] = useAppSelector(fishingFeesAclSelector);
  features['huntingFeesFeature'] = useAppSelector(huntingFeesAclSelector);

  features['reportsFeature'] = useAppSelector(reportsAclSelector);

  features['generalSettingsFeature'] = useAppSelector(generalSettingsAclSelector);
  features['workflowsSettingsFeature'] = useAppSelector(workflowsAclSelector);

  return features;
}

export default useNavMenuFeatures;
